import type {ListServiceFunctionsSearchInput} from "./list-service-functions.schema";

import {keepPreviousData, useQuery} from "@tanstack/react-query";

import {listServiceFunctionsQueryOptions} from "./list-service-functions.query-options";

export function useListServiceFunctions(rawInput: ListServiceFunctionsSearchInput) {
  return useQuery({
    ...listServiceFunctionsQueryOptions(rawInput),
    placeholderData: keepPreviousData,
  });
}
